module.exports = __webpack_public_path__ + "img/7.232bb5e6.png";